import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Box } from '@mui/material';

export default function SelectVariants({ options = [], onChange, value, label, sx }) {

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <Box sx={{ ...sx }}>
      <FormControl variant="standard" sx={{ width: '100%' }}>
        <InputLabel id="demo-simple-select-standard-label">{label}</InputLabel>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={value}
          onChange={handleChange}
          label={label}
        >
          {
            options.map((item, index) => <MenuItem key={index} value={item.value}>{item.displayName}</MenuItem>)
          }
        </Select>
      </FormControl>

    </Box>
  );
}